import { render, staticRenderFns } from "./GenericCampaignOverview.vue?vue&type=template&id=1fb930da&"
import script from "./GenericCampaignOverview.vue?vue&type=script&lang=ts&"
export * from "./GenericCampaignOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports